import { render } from "./CreateModel.vue?vue&type=template&id=c34cc90e"
import script from "./CreateModel.vue?vue&type=script&lang=js"
export * from "./CreateModel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/ideal-ventures/ideal-hr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__